<div class="occ-public-page">
  <div class="container py-5" style="max-width: 680px;">
    <div class="text-center mb-4">
      <span class="brand-badge">✉️</span>
      <h1 class="h2 mt-3 mb-1">Conversa sobre a sua participação</h1>
      <p class="text-muted mb-0">
        Aqui vê o que trocámos consigo e pode responder — sem criar conta.
      </p>
    </div>

    @if (loading()) {
      <div class="card"><div class="card-body text-center text-muted py-5">A carregar…</div></div>
    } @else if (conversation(); as chat) {
      <div class="card mb-4">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div>
              <span class="small text-muted d-block">{{ chat.occurrenceCode }}</span>
              <span class="fw-bold">{{ chat.subject }}</span>
            </div>
            <span class="badge" [class.bg-success-soft]="chat.open" [class.bg-secondary-soft]="!chat.open">
              {{ chat.open ? stateLabels[chat.state] : situationLabels[chat.situation] }}
            </span>
          </div>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-body">
          @if (chat.messages.length === 0) {
            <p class="text-muted mb-0">Ainda não há mensagens nesta conversa.</p>
          } @else {
            @for (message of chat.messages; track message.sentAt) {
              <!-- As nossas ficam à esquerda, as da pessoa à direita: quem lê percebe de quem é
                   sem precisar de nomes nem endereços. -->
              <div class="d-flex mb-3" [class.justify-content-end]="!message.fromUs">
                <div class="p-3 rounded"
                     style="max-width: 85%;"
                     [class.bg-light]="message.fromUs"
                     [class.bg-primary-soft]="!message.fromUs">
                  <p class="mb-1" style="white-space: pre-wrap;">{{ message.body }}</p>
                  <span class="small text-muted">
                    {{ message.fromUs ? 'Equipa' : 'Você' }} · {{ message.sentAt | date: 'dd/MM/yyyy HH:mm' }}
                  </span>
                </div>
              </div>
            }
          }
        </div>
      </div>

      @if (chat.open) {
        <div class="card">
          <div class="card-body">
            <label class="form-label">A sua resposta</label>
            <textarea class="form-control" rows="4" [(ngModel)]="reply"
                      placeholder="Escreva aqui o que quer acrescentar."></textarea>
            @if (error()) { <div class="alert alert-danger mt-3 mb-0">{{ error() }}</div> }
            @if (sent()) { <div class="alert alert-success mt-3 mb-0">Mensagem enviada. Obrigado.</div> }
            <div class="d-flex justify-content-end mt-3">
              <button class="btn btn-primary" (click)="send()" [disabled]="sending() || !reply.trim()">
                {{ sending() ? 'A enviar…' : 'Enviar' }}
              </button>
            </div>
          </div>
        </div>
      } @else {
        <div class="alert alert-secondary">
          A ocorrência foi fechada, por isso a conversa está encerrada. Se precisar de acrescentar
          alguma coisa, <a [routerLink]="['/', tenant, 'participar']">registe uma nova participação</a>.
        </div>
      }
    } @else if (error()) {
      <div class="card"><div class="card-body text-center py-5">
        <p class="text-danger mb-0">{{ error() }}</p>
      </div></div>
    }
  </div>
</div>
